define([
    '../Util/defaultValue',
    '../Util/defined',
    './Vec3Obj'
], function (
    defaultValue,
    defined,
    Vec3Obj) {
    'use strict'

    /**
     * 路径关键点。
     * @param {Vec3Obj} position 位置坐标。
     * @param {Number} [radius=0.0] 转弯半径。
     * @param {Vec3Obj} [orientation=new Vec3Obj(0,0,0)] 朝向，暂不启用。
     * 
     * @alias WayPoint
     * @constructor
     *
     */
    class WayPoint{
        /**
         * @description 在CooWasm中类名。
         * @private
         * @readonly
         */
        className = "WayPoint"
        /**
         * @description 位置坐标。
         * @type {Vec3Obj}
         */
        position
        /**
         * @description 转弯半径。
         * @type {Number}
         */
        radius
        /**
         * @description 朝向。
         * @type {Vec3Obj}
         */
        orientation
        
        constructor(position, radius, orientation) {
            this.position = defaultValue(position, new Vec3Obj(0, 0, 0))
            this.radius = defaultValue(radius, 0.0)
            this.orientation = defaultValue(orientation, new Vec3Obj(0, 0, 0))
        }

        /**
         * 将WayPoint实例转换成json格式的字符串。
         *
         * @returns {String} json格式的字符串。
         */
        toJson(){
            return JSON.stringify(this)
        }

        /**
         * 将json格式的字符串转换成WayPoint实例。
         *
         * @param {String} str json格式的字符串。
         * @param {WayPoint} [result] 如果未定义，将创建一个WayPoint新实例。
         * @returns {WayPoint} WayPoint实例。
         */
        static fromJson(str, result) {
            if (!defined(str)) {
                return undefined
            }
            if (!defined(result)) {
                result = new WayPoint()
            }
            let obj = JSON.parse(str)
            result.position = obj.position
            result.radius = obj.radius
            result.orientation = obj.orientation
            return result
        }
    }
    return WayPoint
})